import React from "react";
import { useNavigate } from "react-router-dom";

interface ModalProps {
  onClose: () => void;
  children: React.ReactNode;
  navigationPath?: string;
  isBlack?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  onClose,
  children,
  navigationPath,
  isBlack = false,
}) => {
  const navigate = useNavigate();
  const handleClose = () => {
    onClose();
    if (navigationPath) {
      navigate(navigationPath);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="shadow-lg p-4 rounded-lg"
        style={{
          background: isBlack ? "#6164ea" : "white",
          borderRadius: "20px",
          padding: 48,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
        }}
      >
        {/* Botón de cerrar */}
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 15,
            right: 15,
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke={isBlack ? "white" : "currentColor"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: 18, height: 18 }}
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {children}
      </div>
    </div>
  );
};

export default Modal;
